import React, { useCallback, useState, memo } from 'react';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import {
  ReportCurrency,
  ReportType,
  ClientCustomCalendarModel,
} from '../../../../models';
import { CustomDateRange } from '../custom-date-range/CustomDateRange';
import { ReportTypeSetting } from '../../../../models/reportTypeSetting';
import { buildDropdownList } from '../helpers/buildReportSettingData';
import ReportSettingPIT from '../ReportSettingPIT';
import { DateRangeMode } from '../date-range/DateRange';

interface ReportSettingMaturityProps {
  onChange: (updatedValue: ReportSettingMaturityState) => void;
  reportSettingState: ReportSettingMaturityState;
  reportTypeSetting: ReportTypeSetting;
  customCalendarSettings?: ClientCustomCalendarModel;
  isAllowPIT?: boolean;
}

export interface ReportSettingMaturityState {
  selectedCurrency: SelectOption<ReportCurrency>;
  shortStartDate: string;
  shortEndDate: string;
  selectedRunBy: SelectOption<string>;
  selectedRunWith: SelectOption<string>;
  selectedEndDateOption: string;
  isValid: boolean;
}

function ReportDateSettingMaturity({
  onChange,
  reportSettingState,
  reportTypeSetting,
  customCalendarSettings,
  isAllowPIT,
}: ReportSettingMaturityProps): JSX.Element {
  const endDateList = buildDropdownList(
    'Maturity',
    'EndDate',
    reportTypeSetting,
    'CustomRadio',
  );
  const [isDateRangeValid, setDateRangeValidStatus] = useState(false);
  const inputHandler = useCallback(
    ({ isValid, ...rest }: ReportSettingMaturityState) => {
      let isValidInput = isDateRangeValid;
      if (isValid !== undefined) {
        isValidInput = isValid;
        setDateRangeValidStatus(isValid);
      }

      onChange({
        ...rest,
        isValid: isValidInput,
      });
    },
    [onChange, isDateRangeValid],
  );
  return (
    <>
      <CustomDateRange
        onChange={useCallback(
          (
            shortStartDate: string,
            shortEndDate: string,
            selectedEndDateOption: string,
            isValid: boolean,
          ): void => {
            inputHandler({
              ...reportSettingState,
              shortStartDate,
              shortEndDate,
              selectedEndDateOption,
              isValid,
            });
          },
          [inputHandler, reportSettingState],
        )}
        shortStartDate={reportSettingState.shortStartDate}
        shortEndDate={reportSettingState.shortEndDate}
        selectedEndDateOption={reportSettingState.selectedEndDateOption}
        endDateList={endDateList}
        customCalendarPeriods={customCalendarSettings.numberOfPeriods}
        endDateMode={DateRangeMode.FullDate}
      />
      <ReportSettingPIT
        reportType={ReportType.maturity}
        isAllowPIT={isAllowPIT}
        reportSettingState={reportSettingState}
        reportTypeSetting={reportTypeSetting}
        customCalendarSettings={customCalendarSettings}
        onChange={useCallback(
          (state) => onChange(state as ReportSettingMaturityState),
          [onChange],
        )}
      />
    </>
  );
}

export default memo(ReportDateSettingMaturity);
